import React from 'react'
import Panel from './components/Panel'

const Section = ({ title, children }) => (
  <Panel>
    <h3 className='text-lg font-semibold text-ink mb-3'>{title}</h3>
    <ol className='pl-5 space-y-2 text-sm text-slate-600 list-decimal'>{children}</ol>
  </Panel>
)

const InstallGuide = () => (
  <div className='space-y-4'>
    <Section title='For iOS Devices'>
      <li>
        Open{' '}
        <a className='text-blue-600 underline' href='https://enterprise.nssurge.com/install' target='_blank' rel='noopener noreferrer'>
          https://enterprise.nssurge.com/install
        </a>{' '}
        on the iOS device with Safari.
      </li>
      <li>
        <a className='text-blue-600 underline' href='itms-services://?action=download-manifest&url=https://dl.nssurge.com/ios/enterprise/manifest.plist'>
          Tap here to install
        </a>.
      </li>
      <li>Return to the home screen and wait until the installation completes.</li>
      <li>After installing, open Settings → General → Profile and trust "Kernel LLC".</li>
      <li>Open Surge and enter your enterprise credentials.</li>
    </Section>
    <Section title='For macOS Devices'>
      <li>
        Download Surge Mac from{' '}
        <a className='text-blue-600 underline' href='https://dl.nssurge.com/mac/v5/Surge-latest.zip' target='_blank' rel='noopener noreferrer'>
          this link
        </a>{' '}
        (same as the personal version).
      </li>
      <li>If the device already has a personal license, deactivate it first.</li>
      <li>Open the app, choose "Already have a license" → "Enterprise License" and enter the credential.</li>
    </Section>
  </div>
)

export default InstallGuide
